import {
    REPROCESS_ODOMETER_HOURS_REQUEST,
    REPROCESS_ODOMETER_HOURS_RESULT,
    REPROCESS_ODOMETER_HOURS_OPEN_MODAL,
    REPROCESS_ODOMETER_HOURS_CLOSE_MODAL,
    REPROCESS_ODOMETER_HOURS_GET_DEVICE_REQUEST,
    REPROCESS_ODOMETER_HOURS_GET_DEVICE_RESULT,
    REPROCESS_ODOMETER_HOURS_SET_DEVICE,
    CLEAR_REDUX,
} from "Redux/actionTypes";

const INIT_STATE = {
    loading: false,
    openModal: false,
    result: null,
    error: null,
    device: null,
    devices: [],
    selectedDevices: [],
    selectedAccount: null
};

export default (state = INIT_STATE, action) => {

    switch (action.type) {
        case REPROCESS_ODOMETER_HOURS_REQUEST:
            return { ...state, loading: true }

        case REPROCESS_ODOMETER_HOURS_RESULT:
            return { ...state, loading: false, result: action.payload }

        case REPROCESS_ODOMETER_HOURS_OPEN_MODAL:
            return { ...state, openModal: true, selectedDevices: action?.payload?.selectedDevices || [], selectedAccount: action?.payload?.selectedAccount || null }

        case REPROCESS_ODOMETER_HOURS_CLOSE_MODAL:
            return { ...state, openModal: false }

        case REPROCESS_ODOMETER_HOURS_GET_DEVICE_REQUEST:
            return { ...state, loading: true }

        case REPROCESS_ODOMETER_HOURS_GET_DEVICE_RESULT:
            return { ...state, loading: false, device: action.payload }

        case REPROCESS_ODOMETER_HOURS_SET_DEVICE:
            return { ...state, devices: action.payload }


        case CLEAR_REDUX:
            return ["", "REPROCESS_ODOMETER_HOURS"].includes(action.payload.option)
                ? action.payload.parameters ? { ...state, ...action.payload.parameters } : { ...INIT_STATE }
                : { ...state }
        default:
            return state;
    }
};